import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { BottomTabBar } from "./BottomTabBar";
import { useIsMobile } from "@/hooks/use-mobile";
import { Spinner } from "@/components/ui/spinner";

export function AppShell() {
  const isMobile = useIsMobile();

  return (
    <div className="flex h-screen overflow-hidden w-full">
      <Sidebar />
      <div className={`flex-1 flex flex-col overflow-hidden min-w-0 pt-safe md:pt-0 ${isMobile ? "" : "md:ml-64"}`}>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-full">
              <Spinner className="size-8" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
      {isMobile && <BottomTabBar />}
    </div>
  );
}
